import { onUnmounted } from 'vue';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useAuthStore } from '@/stores/auth';

const STORAGE_PREFIX = 'tour_completed_';

function getUsername() {
    try {
        const authStore = useAuthStore();
        return authStore.getLoggedInUsernameAndName()?.username || 'default';
    } catch {
        return 'default';
    }
}

function getStorageKey(pageName) {
    return `${STORAGE_PREFIX}${getUsername()}_${pageName}`;
}

function isTourCompleted(pageName) {
    return localStorage.getItem(getStorageKey(pageName)) === 'true';
}

function markTourCompleted(pageName) {
    localStorage.setItem(getStorageKey(pageName), 'true');
}

function clearTourCompleted(pageName) {
    localStorage.removeItem(getStorageKey(pageName));
}

function filterSteps(steps) {
    return steps.filter(step => {
        if (!step.element) return true;
        return document.querySelector(step.element);
    });
}

export function useTour() {
    function startTour(pageName, steps) {
        if (isTourCompleted(pageName)) return;
        executeTour(pageName, steps);
    }

    function resetTour(pageName, steps) {
        clearTourCompleted(pageName);
        executeTour(pageName, steps);
    }

    function executeTour(pageName, steps) {
        try {
            const validSteps = filterSteps(steps);
            if (validSteps.length === 0) return;

            let completed = false;

            const driverObj = driver({
                showProgress: true,
                animate: true,
                overlayColor: 'rgba(0, 0, 0, 0.6)',
                stagePadding: 8,
                stageRadius: 8,
                popoverClass: 'tour-popover',
                nextBtnText: 'Próximo',
                prevBtnText: 'Anterior',
                doneBtnText: 'Concluir',
                onDestroyStarted: () => {
                    if (!driverObj.hasNextStep()) {
                        completed = true;
                    }
                    driverObj.destroy();
                },
                onDestroyed: () => {
                    if (completed) {
                        markTourCompleted(pageName);
                    }
                },
                steps: validSteps
            });

            driverObj.drive();
        } catch (e) {
            console.error('[Tour] Falha ao iniciar:', e);
        }
    }

    function registerTourListener(pageName, stepsFn) {
        const handler = () => resetTour(pageName, stepsFn());
        window.addEventListener('restart-tour', handler);
        onUnmounted(() => window.removeEventListener('restart-tour', handler));
    }

    return { startTour, resetTour, isTourCompleted, registerTourListener };
}
